const data = {
    aboutDescription1: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    aboutDescription2: "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    aboutInfo: [
        {
            title: "What is Lorem Ipsum?",
            text: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit"
        },
        {
            title: "What is Lorem Ipsum?",
            text: 'Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure.'
        },
        {
            title: "Where can I get some?",
            text: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered'
        }
    ]
}

export default data;